import { stateMapLayer, statePreferences } from '@/selectors/selectors';
import { useDispatch, useSelector } from '@/state/store';
import { forwardRef, useCallback } from 'react';
import { setMapLayer as _setMapLayer } from '../../../actions/mapActions';
import { MapLayerType } from '../map-utils/WebMapTileServices';
import { MapControlMenu } from './MapControlMenu';
import { MapControlMenuOption } from './MapControlMenuOption';

const TileServiceSelection = forwardRef<HTMLButtonElement>((_, ref) => {
    const mapLayer = useSelector(stateMapLayer);
    const preferences = useSelector(statePreferences);
    const dispatch = useDispatch();
    const changeTileService = useCallback(
        (layer: MapLayerType) => {
            if (mapLayer !== layer) {
                dispatch(_setMapLayer(layer));
            }
        },
        [dispatch, mapLayer]
    );

    return (
        <MapControlMenu
            ref={ref}
            id="map-layer-options"
            label="Kartlagvelger"
            title="Åpne kartlagvelger"
            expandedTitle="Lukk kartlagvelger"
            icon={<i className="o-icon-layer c-zoom-controls__layer-icon" />}
        >
            {[
                <MapControlMenuOption
                    key="standard"
                    label={'Standard'}
                    active={mapLayer === MapLayerType.STANDARD}
                    iconName={'o-icon-map-default'}
                    onClick={() => changeTileService(MapLayerType.STANDARD)}
                />,
                <MapControlMenuOption
                    key="topografisk"
                    label={'Topografisk'}
                    active={mapLayer === MapLayerType.TOPOGRAFISK}
                    iconName={'o-icon-map-landscape'}
                    onClick={() => changeTileService(MapLayerType.TOPOGRAFISK)}
                />,
                <MapControlMenuOption
                    key="graatone"
                    label={'Gråtone'}
                    active={mapLayer === MapLayerType.GRAATONE}
                    iconName={'o-icon-map-grayscale'}
                    onClick={() => changeTileService(MapLayerType.GRAATONE)}
                />,
                <MapControlMenuOption
                    key="flyfoto"
                    label={'Flyfoto'}
                    active={mapLayer === MapLayerType.FLYFOTO}
                    iconName={'o-icon-map-photograph'}
                    onClick={() => changeTileService(MapLayerType.FLYFOTO)}
                />,
                ...(preferences.showDeveloperSettings
                    ? [
                          <MapControlMenuOption
                              key="openstreetmap"
                              label={'OpenStreet'}
                              active={mapLayer === MapLayerType.OPENSTREETMAP}
                              iconName={'o-icon-map-default'}
                              onClick={() =>
                                  changeTileService(MapLayerType.OPENSTREETMAP)
                              }
                          />,
                          <MapControlMenuOption
                              key="kanvas"
                              label={'Kanvas'}
                              active={mapLayer === MapLayerType.KANVAS}
                              iconName={'o-icon-map-note'}
                              onClick={() => changeTileService(MapLayerType.KANVAS)}
                          />,
                          <MapControlMenuOption
                              key="kanvas-mork"
                              label={'Kanvas - Mørk'}
                              active={mapLayer === MapLayerType.KANVAS_MORK}
                              iconName={'o-icon-map-note'}
                              onClick={() => changeTileService(MapLayerType.KANVAS_MORK)}
                          />,
                          <MapControlMenuOption
                              key="basis"
                              label={'Basis'}
                              active={mapLayer === MapLayerType.BASIS}
                              iconName={'o-icon-map-bus'}
                              onClick={() => changeTileService(MapLayerType.BASIS)}
                          />,
                          <MapControlMenuOption
                              key="basis-graa"
                              label={'Basis - Grå'}
                              active={mapLayer === MapLayerType.BASIS_GRAATONE}
                              iconName={'o-icon-map-bus'}
                              onClick={() =>
                                  changeTileService(MapLayerType.BASIS_GRAATONE)
                              }
                          />,
                      ]
                    : []),
            ]}
        </MapControlMenu>
    );
});

TileServiceSelection.displayName = 'TileServiceSelection';
export { TileServiceSelection };
